import React from "react";
import { useParams } from "react-router-dom";
import useScoFormsEnabled from "../../hooks/useScoFormsEnabled";
import CreateUsersPage from "./CreateUsersPage";
import LegacyCreateUsersPage from "./LegacyCreateUsersPage";
import LoadingTablePage from "../LoadingTablePage";

/**
 * Picks the create page by the agreement's SCO flag (PBI #386): the SCO onboarding form when
 * it is on, the production create-user page otherwise. Decided here rather than inside
 * CreateUsersPage, which starts its SCO fetches on mount.
 */
const CreateUserRoute = () => {
  const { agreementPublicId } = useParams();
  const { enabled, loaded } = useScoFormsEnabled(agreementPublicId);

  if (!loaded) return <LoadingTablePage title={"Users"} loading={true} />;
  return enabled ? <CreateUsersPage /> : <LegacyCreateUsersPage />;
};

export default CreateUserRoute;
